export const removeToasterChildren = (toaster: React.MutableRefObject<HTMLDivElement | null>) => {
  toaster.current?.childNodes.forEach((el) => el.remove());
};
